module.exports = __webpack_public_path__ + "img/python.117ee0a1.png";